if (!customElements.get('sticky-mobile-buy-bar')) {
  customElements.define(
    'sticky-mobile-buy-bar',
    class StickyMobileBuyBar extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.targetButton = document.getElementById(this.dataset.targetButton);
        this.priceEl = this.querySelector('.sticky-mobile-buy-bar__price');
        this.buttonEl = this.querySelector('.sticky-mobile-buy-bar__button');
        this.buttonLabelEl = this.buttonEl?.querySelector('span');
        this.originalLabel = this.buttonLabelEl?.textContent;
      }

      connectedCallback() {
        // The bar proxies clicks to the real submit button; without one it is dead weight.
        if (!this.targetButton) {
          this.style.display = 'none';
          return;
        }
        this.buttonEl?.addEventListener('click', this.handleClick.bind(this));
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.handleVariantChange.bind(this)
        );
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      handleVariantChange({ data: { sectionId, html, variant } }) {
        if (sectionId !== this.sectionId) return;

        const priceSource = html?.getElementById?.(`price-${sectionId}`);
        if (this.priceEl && priceSource) {
          this.priceEl.innerHTML = priceSource.innerHTML;
        }

        const unavailable = !variant;
        const soldOut = !!variant && variant.available === false;

        if (this.buttonEl) {
          this.buttonEl.disabled = unavailable || soldOut;
        }
        if (this.buttonLabelEl) {
          // originalLabel may be "Sold out" when the landing variant was sold
          // out, so an available variant must use the theme's add-to-cart string.
          this.buttonLabelEl.textContent = unavailable
            ? window.variantStrings?.unavailable
            : soldOut
            ? window.variantStrings?.soldOut
            : window.variantStrings?.addToCart || this.originalLabel;
        }
      }

      handleClick() {
        if (this.buttonEl?.disabled) return;
        this.targetButton?.click();
      }
    }
  );
}
